import BaseTableDataConverter from "../../table/BaseTableDataConverter";
import {RowType} from "../../table/RowType";

export default class TableDataConverter extends BaseTableDataConverter {
    constructor(data, params) {
        super(data, params);
        this.groupingLevels = [
            params.firstGroupingLevel,
            params.secondGroupingLevel,
            params.thirdGroupingLevel,
            params.fourthGroupingLevel
        ];
    }

    _createHeader() {
        return {
            type: RowType.HEADER
        };
    }

    _createDataRow(level, type, groupingType, item) {
        var dataRow = _.pick(item,
            'id',
            'totalSpentTime',
            'estimatedTime',
            'spentTimeForEstimated',
            'spentTimeForNotEstimated',
            'varianceTime',
            'varianceTimeInPercentage');
        dataRow.level = level;
        dataRow.type = type;
        dataRow.groupingType = groupingType;
        return dataRow;
    }

    getGroupingLevels(params) {
        var array = [];
        array.push(params.firstGroupingLevel);
        array.push(params.secondGroupingLevel);
        array.push(params.thirdGroupingLevel);
        array.push(params.fourthGroupingLevel);
        return array;
    }

    getGroupingLevelsCollapsed(groupingLevels) {
        return EVAReport.ConvertUtils.getGroupingLevelsCollapsed(groupingLevels)
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/estimatedVsActualReport/Table/TableDataConverter.js